<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information">
<p style="text-indent: 0em; padding-top: 75px; text-align: center;"><strong><em>Crucible</em></strong></p>
<p style="text-indent: 0em; text-align: center;"><em>A situation of severe trial or in which different elements interact, leading to the creation of something new.</em></p>
<p style="text-indent:0em;"><em><br/>
</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?3cc79565